import "./TopMenuLinks.scss"

import classNames from "classnames"
// import PropTypes from "prop-types"
import React from "react"

import {
  CANADA_HAMILTON,
  CANADA_WATERLOO
} from "../../../constants/routes"
import config from "../../../utils/config"
import NavLink from "../../atoms/NavLink"

const TopMenuLinksCanada = ({ switchLanguage, isFrench }) => {
  const topMenuLinksClass = classNames("top-menu-links-wrapper")
  return (
    <div className={topMenuLinksClass}>
      <div className="Navbar--links">
        <NavLink to={`${config.LANDLINE_URL}${CANADA_HAMILTON}`}>Hamilton (YHM)</NavLink>
        <NavLink to={`${config.LANDLINE_URL}${CANADA_WATERLOO}`}>Waterloo/Kitchener (YKF)</NavLink>
        <NavLink to="#" onClick={switchLanguage}>{isFrench ? "EN" : "FR"}</NavLink>
      </div>
    </div>
  )
}

TopMenuLinksCanada.propTypes = {}

TopMenuLinksCanada.defaultProps = {}

export default TopMenuLinksCanada
